module.exports = __webpack_public_path__ + "eov-front.png?ca45b31bb3bee5828a5de5acbec0462a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eov/eov-front.png
// module id = 25
// module chunks = 0